<template>
  <div class="details">
    <div class="sec-block1 sec-block2" v-if="typePage !== 'course' && !answerForcedDisplay">
      <div class="title2">
        答题次数:
        <span class="num-txt">{{ conditionsObj && conditionsObj.userInspectNum }}</span>
      </div>
      <div class="btns">
        <div class="show-answer-btn" v-if="!answerForcedDisplay" @click="handleShowAnswer">
          答案展示
        </div>
        <div class="reset-btn" v-if="conditionsObj && conditionsObj.anewInspect" @click="handleClickReset">
          <img src="@/assets/images/grade/img4.png" class="icon-reset" alt="">
          重新答题
        </div>
      </div>
    </div>
    <div class="sec-block1">
      <div class="title">题目描述</div>
      <div class="abs-btn">
        <div class="btn-txt" @click="hanldeShowDialog">题目列表</div>
        <div class="case-num">
          <span class="num-col">{{ curTopic && curTopic.curIndex }}</span>
          /{{ topicList && topicList.length }}
        </div>
      </div>
    </div>
    <template v-if="dayDetails">
      <itemComponents ref="itemSwitch" :topicList="topicList" :dayDetails="dayDetails" :questionImage="questionImage"
                      :questionVideo="questionVideo" :itemIds="itemIds" :trueAnswerId="trueAnswerId"
                      :answerStatus="answerStatus"
                      :userAnswer="userAnswer" :answerIsTrue="answerIsTrue" :trueTxt="trueTxt"
                      :analysisVideo="analysisVideo"
                      :questionCourses="questionCourses" :questionDocuments="questionDocuments"
                      :questionCases="questionCases"
                      @swipe-change="onChange" @image-click="handleClickImgs" @question-video-click="handleClickQuesion"
                      @option-click="handleClickItems" @play-video="handlePlayVideo" @resource-click="handleClick"
                      :answerForcedDisplay="answerForcedDisplay"/>
    </template>
    <div class="fix-btn">
      <div class="btn-txt"
           v-if="answerStatus === '2' && !showConfirmBtn && !isAnswerBool && !answerForcedDisplay"
           @click="handleSubmit">
        确认答案
      </div>
      <div class="flex-btn">
        <div class="btn-item" @click="handlePrevTopic">
          <img src="@/assets/images/questionBank/img(9).png" class="item-icon" alt=""/>
          <div class="item-txt">上一题</div>
        </div>
        <div class="btn-item" @click="handleNextTopic">
          <img src="@/assets/images/questionBank/img(17).png" class="item-icon" alt=""/>
          <div class="item-txt">下一题</div>
        </div>
      </div>
    </div>
    <indexComponents :showAll="showDialog" :topicList="topicList" @update:showAll="showDialog = $event"
                     @topic-click="handleClickTopic"/>
    <div class="dialog-video" v-if="videoDialog">
      <div class="dialog-video-bg" @click.stop="handlePauseVideo"></div>
      <VideoPlayerAnswer ref="video" :playerVideo="analysisVideo"></VideoPlayerAnswer>
    </div>
    <van-overlay :show="showImage" class="loading-overlay">
      <van-loading type="spinner"/>
    </van-overlay>
    <dialogDel ref="dialogDel" @handleDelSave="handleDelSave" :dialogHeadTxt="dialogHeadTxt"
               :delMessage="delMessage"></dialogDel>
  </div>
</template>
<script>
import {ImagePreview} from 'vant'
import {
  setSha,
  stopScroll,
  canScroll,
  debounce,
  traceClickURL,
} from '../../utils/util'
import VideoPlayerAnswer from '@/views/home/components/VideoPlayerAnswer.vue'
// import { getShareInfo } from '@/utils/wxShare'
import withRouteTracking from '@/utils/withRouteTracking'
import itemComponents from '@/components/questionCom/itemComponents.vue'
import indexComponents from '@/components/questionCom/indexComponents.vue'
import {
  gradeQuestionList,
  gradeAnswerQuestion,
  courseQuestion,
  conditions,
  resetExam,
  classUserBusiness
} from '@/api/grade.js'
import dialogDel from './components/dialogDel.vue'
import {isScorm} from '../../api/scorm'
import {getIsCorrect} from '../../api/grade'

const UserProfile = {
  components: {
    VideoPlayerAnswer,
    itemComponents,
    indexComponents,
    dialogDel
  },
  data() {
    return {
      dayDetails: {},
      questionImage: {},
      questionVideo: {},
      showDialog: false,
      questionOptions: [],
      itemIds: [],
      topicList: [],
      curTopic: {},
      curSwiperIndex: 0,
      answerStatus: '-1',
      // 知识来源课程
      questionCourses: [],
      // 知识来源文献
      questionDocuments: [],
      // 知识来源病例
      questionCases: [],
      // 解析视频
      analysisVideo: {},
      trueTxt: '',
      answerIsTrue: '',
      videoDialog: false,
      userAnswer: [],
      showImage: false,
      showConfirmBtn: false,
      isAnswerBool: false,
      campId: '',
      whichDay: '',
      allQues: [],
      trueAnswerId: [],
      conditionsObj: {},
      delMessage: '确认删除吗?',
      dialogHeadTxt: '提示'
    }
  },
  mounted() {
    this.postbarId = this.$route.query.postbarId
    canScroll()
    this.handleFun()
    this.handleConditions()
    window.vueThis = this
  },
  beforeDestroy() {
    sessionStorage.removeItem('video-track-cache')
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    typePage() {
      return this.$route.query.typePage
    },
    courseId() {
      return this.$route.query.courseId
    },
    // 直接显示答案: 点击过答案显示按钮 / 最后一次答题且最后一次答题完毕
    answerForcedDisplay() {
      return this.conditionsObj.userInspectBusiness || (!this.conditionsObj.anewInspect && this.conditionsObj.userInspectComplete)
    }
  },
  methods: {
    handleShowAnswer() {
      this.dialogHeadTxt = '答案展示'
      this.$refs.dialogDel.init()
      this.delMessage = '如您现在需要查看答案，本次考试将立即结束，且无法再次答题，请确认是否继续？'
      this.dialogConType = 'handleShowAnswer'
    },
    async handleClickReset() {
      try {
        await resetExam({'iepUserId': this.userInfo.id, 'baseId': this.postbarId})
        this.isAnswerBool = false
        await this.handleFun()
        await this.handleConditions()
      } catch (e) {
        throw e
      }
    },
    async handleConditions() {
      if (!this.userInfo || !this.userInfo.id || !this.postbarId) return
      try {
        const res = await conditions({
          userId: this.userInfo.id,
          baseId: this.postbarId
        })
        this.conditionsObj = res.data
      } catch (e) {
        throw e
      }
    },
    // 跳转到指定题目
    handleClickTopic(index) {
      if (index + 1 === this.curTopic.curIndex) return
      this.resetQuestionState()
      this.$refs.itemSwitch.$refs.vantSwiper.swipeTo(index)
    },

    // 显示/隐藏题目序列号对话框
    hanldeShowDialog() {
      this.showDialog = !this.showDialog
    },

    // 上一题
    handlePrevTopic: debounce(() => {
      const _this = window.vueThis
      if (_this.dayDetails.id === _this.topicList[0].id) {
        _this.$toast('这里是第一题！')
        return
      }
      const prevIndex =
        _this.topicList.findIndex((res) => res.id === _this.dayDetails.id) - 1
      _this.isAnswerBool = false
      _this.handleClickTopic(prevIndex)
    }, 100),

    // 下一题
    handleNextTopic: debounce((type) => {
      const _this = window.vueThis
      const lastIndex = _this.topicList.length - 1
      if (_this.dayDetails.id === _this.topicList[lastIndex].id) {
        _this.$toast('您已到最后一题！')
        if (type === 'submit') {
          _this.hanldeShowDialog()
        }
        return
      }
      const nextIndex =
        _this.topicList.findIndex((res) => res.id === _this.dayDetails.id) + 1
      _this.isAnswerBool = false
      _this.handleClickTopic(nextIndex)
    }, 100),

    // Swiper 切换回调
    onChange(e) {
      this.curSwiperIndex = e
      this.topicList[e].curIndex = e + 1
      this.curTopic = this.topicList[e]
      this.questionId = this.topicList[e].id
      const checkData = this.allQues.data.find(
        (item) => item.id === this.questionId
      )
      this.getQuestionData(checkData)
    },

    // 提交答案
    handleSubmit() {
      if (this.itemIds.length === 0) {
        this.$toast('作题答案不能为空！')
        return
      }
      if (this.dayDetails.questionType === '2' && this.itemIds.length < 2) {
        this.$toast('该题为多选题，请至少选择两个选项！')
        return
      }
      this.handleSubmitCon()
    },

    // 提交答案的具体逻辑
    handleSubmitCon() {
      const params = {
        questionId: this.questionId,
        iepUserId: this.userInfo.id,
        optionIds: this.itemIds,
        baseId: this.typePage === 'course' ? this.courseId : this.postbarId,
      }
      if (this.conditionsObj && Object.keys(this.conditionsObj).length > 0) {
        params.answerNum = this.conditionsObj.userInspectNum
      }
      this.isAnswerBool = true
      gradeAnswerQuestion(params)
        .then(res => {
          this.handleFun()
          this.handleConditions()
          this.handlePassOrNot(res)
        })
        .catch((err) => {
          this.isAnswerBool = false
          this.$toast(err.msg)
        })
    },

    async getAnswerIsTrue() {
      try {
        const result = await getIsCorrect({
          baseId: this.typePage === 'course' ? this.courseId : this.postbarId,
          userId: this.userInfo.id,
          questionId: this.questionId
        })
        if (result.code === 0) {
          this.answerIsTrue = `${result.data}`
          return
        }
        this.answerIsTrue = ''
      } catch (e) {
      }
    },

    async handleDelSave() {
      if (this.dialogConType === 'handleShowAnswer') {
        try {
          const res = await classUserBusiness({
            userId: this.userInfo.id,
            baseId: this.postbarId,
            baseType: 1
          })
          if (res.code === 0) {
            this.$refs.dialogDel.handleClose()
            await this.$router.replace({
              path: '/gradeQuestion',
              query: {
                postbarId: this.postbarId
              }
            })
            await this.handleFun()
            await this.handleConditions()
          } else {
            this.$toast(res.msg)
          }
        } catch (e) {
          throw e
        }
      }
      if (this.dialogConType === 'gradeQuestion') {
        this.$refs.dialogDel.handleClose()
      }
    },

    handlePassOrNot(res) {
      if (res.code === 0) {
        const {answerCompleted, passOrNot} = res.data
        if (answerCompleted) {
          this.dialogHeadTxt = '考试结果'
          this.$refs.dialogDel.init()
          const status = passOrNot ? '通过' : '不通过'
          const baseStyle = `margin-top: 5px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 16px;`
          const stylePass = `${baseStyle} color: #328714;`
          const styleFail = `${baseStyle} color: #EB1700;`
          const style = passOrNot ? stylePass : styleFail
          this.delMessage = `您好，您本场考试结果为 <br/> <div style="${style}">${status}</div>`
          this.dialogConType = 'gradeQuestion'
        }
      }
    },

    // 点击图片预览
    handleClickImgs() {
      this.showImage = true
      this.imgToBase64(this.questionImage.url).then((imgUrl) => {
        this.showImage = false
        ImagePreview({ images: [imgUrl], showIndex: false, closeable: true })
      })
    },

    // 点击题目视频播放
    handleClickQuesion() {
      this.setVideoTrackCache(this.dayDetails && this.dayDetails.id)
      this.resetVideoTraceSession()
      this.analysisVideo = this.dayDetails.questionVideo
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId =
          this.dayDetails.questionVideoId
        this.$refs.video.player.play()
      })
    },

    // 点击选项
    handleClickItems(id) {
      if (this.answerForcedDisplay) return
      if (this.answerStatus !== '2') return
      if (this.dayDetails.questionType === '1') {
        this.itemIds = [id]
      } else {
        this.itemIds = this.itemIds.includes(id)
          ? this.itemIds.filter((res) => res !== id)
          : [...this.itemIds, id]
      }
    },

    // 获取题目数据
    async handleFun() {
      const params1 = {postbarId: this.postbarId}
      const params2 = {courseId: this.courseId} // this.courseId
      this.allQues = this.typePage === 'course' ? await courseQuestion(params2) : await gradeQuestionList(params1)
      this.questionId = this.allQues.data[this.curSwiperIndex] && this.allQues.data[this.curSwiperIndex].id
      this.topicList = this.allQues.data
      const currentTopic = this.topicList.find((item, index) => item.id === this.questionId)
      if (currentTopic) {
        currentTopic.curIndex = this.curSwiperIndex + 1
        this.$refs.itemSwitch.$refs.vantSwiper.swipeTo(this.curSwiperIndex)
        this.curTopic = currentTopic
      }
      this.getQuestionData(currentTopic)
    },

    // 获取题目详情
    async getQuestionData(res) {
      if (!res) {
        this.$toast('暂无题目,请联系管理员！')
        return
      }
      this.answerIsTrue = ''
      if (res.userAnswer && res.userAnswer.length > 0) {
        await this.getAnswerIsTrue()
      }
      this.dayDetails = res
      window.sessionStorage.setItem('mainId', res.id)
      this.setVideoTrackCache(res.id)
      this.answerStatus = `${res.answerStatus}`
      this.userAnswer = res.userAnswer || []
      this.itemIds =
        this.userAnswer.length > 0 && res.answerStatus !== '2'
          ? this.userAnswer.map((item) => item.questionOption.id).sort()
          : []
      this.questionOptions = res.questionOptions.map((item) => ({
        ...item,
        isCheck: false,
      }))
      this.questionImage = res.questionImage || {}
      this.questionVideo = res.questionVideo || {}
      this.trueAnswerId = res.questionAnswers
        .map((item) => item.optionAnswer.id)
        .sort()
      this.trueTxt = res.questionAnswers
        .map((item) => item.optionAnswer.optionContent)
        .toString()
      this.questionCourses = res.questionCourses || []
      this.questionDocuments = res.questionDocuments || []
      this.questionCases = res.questionCases || []
      this.analysisVideo = res.analysisVideo || {}
    },

    // 跳转知识点来源
    async handleClick({type, item}) {
      const openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      const trackParams = `&entrance=55&businessChannel=55&campId=${this.dayDetails.journeyId}`
      const iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (type === 'course') {
        window.sessionStorage.setItem('entrance', '55')
        const query = {
          courseId: item.courseId,
          journeyId: this.dayDetails.journeyId,
          businessId: this.dayDetails.journeyId,
          entrance: '55',
          channel: '55'
        }
        const isscorm = await isScorm(item.courseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      } else if (type === 'case') {
        setTimeout(traceClickURL)
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.caseId}${openid}&id=${item.caseId}${trackParams}`
      } else if (type === 'document') {
        setTimeout(traceClickURL)
        window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.documentId}${openid}${iepTxt}${trackParams}`
      }
    },

    // 播放视频
    handlePlayVideo() {
      this.setVideoTrackCache(this.dayDetails && this.dayDetails.id)
      this.resetVideoTraceSession()
      this.analysisVideo = this.dayDetails.analysisVideo
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId =
          this.dayDetails.analysisVideo.id
        this.$refs.video.player.play()
      })
    },

    // 暂停视频
    handlePauseVideo() {
      this.resetVideoTraceSession()
      this.videoDialog = false
      canScroll()
      this.$refs.video.player.pause()
    },
    resetVideoTraceSession() {
      if (this.videoDialog && this.$refs.video && this.$refs.video.handleVideoTrace) {
        this.$refs.video.handleVideoTrace(this.$refs.video.curVideoPlayer)
      }
      sessionStorage.removeItem('curPlaySessionVideo')
      sessionStorage.removeItem('videoSectionId')
      sessionStorage.removeItem('videoTraceId')
    },

    setVideoTrackCache(questionId) {
      const entrance = this.$route.query.entrance || sessionStorage.getItem('entrance') || '55'
      const channel = (entrance === '1' || entrance === '2' || entrance === '3') ? entrance : this.$route.query.channel || '55'
      const campId = questionId || ''
      sessionStorage.setItem('video-track-cache', JSON.stringify({
        entrance,
        campId,
        channel
      }))
    },

    // 图片转 Base64
    async imgToBase64(url) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.src = url
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = image.naturalWidth
          canvas.height = image.naturalHeight
          const ctx = canvas.getContext('2d')
          if (!ctx) return reject(new Error('Canvas context not available'))
          ctx.drawImage(image, 0, 0)
          const base64 = canvas.toDataURL('image/jpeg')
          resolve(base64)
        }
        image.onerror = reject
      })
    },

    // 重置题目状态
    resetQuestionState() {
      this.dayDetails = {}
      this.questionImage = {}
      this.itemIds = []
      this.questionOptions = []
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.details {
  position: relative;
  background-color: #fff;
  padding: 15px;
  padding-bottom: 110px;
  box-sizing: border-box;

  .sec-block1 {
    position: relative;

    &.sec-block2 {
      height: 34px;
      width: 100vw;
      left: -15px;
      top: -15px;
      background-color: #F5F5F5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      box-sizing: border-box;

      .title2 {
        font-size: 14px;
        color: #333333;

        .num-txt {
          font-weight: 600;
          margin-left: 4px;
        }
      }

      .btns {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .show-answer-btn {
        margin-right: 8px;
        width: 68px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #333333;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
      }

      .reset-btn {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background-color: #EB1700;
        color: #fff;
        justify-content: center;
        font-weight: 500;
        font-size: 12px;
        width: 90px;
        height: 24px;

        .icon-reset {
          display: block;
          width: 12px;
          margin-right: 4px;
        }
      }
    }
  }

  .title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    padding-left: 8px;
    box-sizing: border-box;
    line-height: 20px;
    position: relative;
    margin-bottom: 8px;

    &::before {
      position: absolute;
      width: 4px;
      left: 0;
      top: 4px;
      height: 12px;
      border-radius: 100px;
      background-color: #EB1700;
      content: "";
    }
  }

  .abs-btn {
    position: absolute;
    right: 0;
    top: -3px;
    display: flex;
    align-items: center;

    .btn-txt {
      padding: 0 4px;
      height: 22px;
      border-radius: 4px;
      border: 1px solid #EB1700;
      color: #EB1700;
      font-size: 12px;
      text-align: center;
      line-height: 22px;
      margin-right: 16px;
      box-sizing: border-box;
    }

    .case-num {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #333333;

      .num-col {
        color: #EB1700;
      }
    }
  }

  .div-txt {
    font-size: 14px;
    color: #333333;
    margin-bottom: 8px;
  }

  .fix-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    border-top: 1px solid #f1f1f1;
    padding: 8px 10px;
    box-sizing: border-box;
    width: 100vw;
    z-index: 9;

    .btn-txt {
      width: 100%;
      height: 40px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 40px;
      background-color: #EB1700;
      border-radius: 100px;
      margin-bottom: 18px;
    }

    .flex-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btn-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item-icon {
          width: 20px;
          height: 20px;
          display: block;
          margin-bottom: 4px;
        }

        .item-txt {
          font-size: 14px;
          line-height: 16px;
          color: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background-color: #fff;
    padding: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #a9aeb6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-con {
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 30px;
      background: rgba(0, 0, 0, 0.02);
      font-size: 14px;
      color: #333;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: "*";
        font-size: 17px;
        color: #ff0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 20px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>
<style scoped>
.dialog-video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.dialog-video-bg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.6);
}

.player {
  position: relative;
  width: 100%;
  height: 200px;
  top: 50%;
  margin-top: -50%;
  z-index: 99999;
}

.player.isFullPlayer {
  position: static;
  height: auto;
  top: 0;
  margin-top: 0;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/gradeQuestion.vue